"use client";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ChatPopup from "../../src/components/home/ChatPopup.js";
import SocialAccountCard from "../../src/components/socialAccountCard/SocialAccountCard.js";

import { TextField, InputAdornment, IconButton, Fab } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LanguageIcon from '@mui/icons-material/Language';
import GitHubIcon from '@mui/icons-material/GitHub';

function SocialPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const language = useSelector((state) => state.language.language);

  const text = {
    cardEmail: language === "en" ? "Email Us " : "हमें ईमेल करें",
    cardCall: language === "en" ? "Call Us " : "हमें कॉल करें",
    cardLocation: language === "en" ? "Location " : "स्थान",
    cardLocationDescription:
      language === "en"
        ? "G- 276 Sector 22 Near by Federal Bank Noida Utter Pradesh, Pin code 201301 "
        : "ब्लॉक ए4, सेक्टर 16, नोएडा, उत्तर प्रदेश 201301",
  };

  // Social accounts list
  const socialAccounts = [
    { id: 1, name: "Instagram", title: "Follow us on Instagram", icon: <InstagramIcon style={{ color: "#E1306C" }} />, url: "https://www.instagram.com/dtdb_makeover_official/" },
    { id: 2, name: "Facebook", title: "Like our Facebook Page", icon: <FacebookIcon style={{ color: "#1877F2" }} />, url: "#" },
    { id: 3, name: "YouTube", title: "Watch videos on YouTube", icon: <YouTubeIcon style={{ color: "#FF0000" }} />, url: "#" },
    { id: 4, name: "Twitter", title: "Follow us on Twitter", icon: <TwitterIcon style={{ color: "#1DA1F2" }} />, url: "#" },
    { id: 5, name: "LinkedIn", title: "Connect with us on LinkedIn", icon: <LinkedInIcon style={{ color: "#0A66C2" }} />, url: "https://in.linkedin.com/in/door-to-door-beauty-a90262346" },
    { id: 6, name: "Pinterest", title: "Explore beauty ideas on Pinterest", icon: <PinterestIcon style={{ color: "#E60023" }} />, url: "https://www.pinterest.com/doortodoorbeauty/" },
    { id: 7, name: "Plurk", title: "Follow us on Plurk", icon: <LanguageIcon style={{ color: "#CF3A24" }} />, url: "#" },
    { id: 8, name: "Tumblr", title: "Follow us on Tumblr", icon: <LanguageIcon style={{ color: "#34526f" }} />, url: "https://www.tumblr.com/blog/doortodoorbeauty" },
    { id: 9, name: "Instapaper", title: "Bookmark us on Instapaper", icon: <LanguageIcon style={{ color: "#000000" }} />, url: "https://www.instapaper.com/p/dtdb" },
    { id: 10, name: "Quora", title: "Follow us on Quora", icon: <LanguageIcon style={{ color: "#b92b27" }} />, url: "https://www.quora.com/profile/Doortodoor-Beauty" },
    { id: 11, name: "Reddit", title: "Join the conversation on Reddit", icon: <LanguageIcon style={{ color: "#FF4500" }} />, url: "https://www.reddit.com/user/doortodoorbeauty" },  
    { id: 12, name: "Dribbble", title: "See our designs on Dribbble", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "https://dribbble.com/doortodoorbeauty" },
    { id: 13, name: "4shared.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "https://www.4shared.com/u/_VrYeVgA/doortodoorbeauty4.html" },



    { id: 14, name: "about.me", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "https://about.me/doortodoorbeauty" },
    { id: 15, name: "academia.edu", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 16, name: "allmusic.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 17, name: "angel.co ", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 18, name: "archive.org", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 19, name: "bandcamp.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 20, name: "bebo.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 21, name: "behance.net", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 22, name: "bit.ly", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 23, name: "bitbucket.org", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 24, name: "blackplanet.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 25, name: "blogger.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 26, name: "bloglovin.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 27, name: "blogtalkradio.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 28, name: "blurb.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 29, name: "box.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 30, name: "buzznet.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 31, name: "cafemom.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 32, name: "care2.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 33, name: "change.org", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 34, name: "classmates.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 35, name: "coub.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 36, name: "coursera.org", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 37, name: "crunchbase.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 38, name: "dailystrength.org", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 39, name: "deviantart.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 40, name: "diigo.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 41, name: "discogs.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 42, name: "disqus.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 43, name: "eater.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 44, name: "etsy.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 45, name: "evernote.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 46, name: "fanpop.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 47, name: "flickr.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 48, name: "flixster.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 49, name: "genius.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 50, name: "giphy.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 51, name: "Github", title: "See our designs on Github", icon: <GitHubIcon style={{ color: "#EA4C89" }} />, url: "https://github.com/doortodoorbeauty" },
    { id: 52, name: "Gitlab", title: "See our designs on Gitlab", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "https://gitlab.com/doortodoorbeauty/" },
    { id: 53, name: "goodreads.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 54, name: "gravatar.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 55, name: "ibm.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 56, name: "imdb.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "https://www.imdb.com/user/ur194514625/" },
    { id: 57, name: "imgur.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 58, name: "indiegogo.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 59, name: "instructables.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 60, name: "kickstarter.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 61, name: "last.fm", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 62, name: "letterboxd.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 63, name: "livejournal.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 64, name: "liveleak.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 65, name: "magcloud.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 66, name: "mediafire.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 67, name: "medium.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 68, name: "meetme.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 69, name: "minds.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 70, name: "mixcloud.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 71, name: "moz.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 72, name: "mubi.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 73, name: "myanimelist.net", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 74, name: "myspace.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 75, name: "pearltrees.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 76, name: "polygon.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 77, name: "producthunt.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 78, name: "racked.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 79, name: "ravelry.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 80, name: "reverbnation.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 81, name: "rottentomatoes.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 82, name: "sbnation.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 83, name: "scoop.it", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 84, name: "scribd.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 85, name: "sketchfab.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 86, name: "slashdot.org", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 87, name: "soundclick.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 88, name: "soundcloud.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 89, name: "sourceforge.net", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 90, name: "stackoverflow.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 91, name: "tagged.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 92, name: "ted.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 93, name: "theverge.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 94, name: "tripadvisor.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 95, name: "trustpilot.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 96, name: "ultimate-guitar.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 97, name: "visual.ly", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 98, name: "vox.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 99, name: "weebly.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 100, name: "wordpress.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 101, name: "xanga.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },
    { id: 102, name: "yumpu.com", title: "See our designs on 4shared", icon: <LanguageIcon style={{ color: "#EA4C89" }} />, url: "#" },

  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Scroll button visibility handler
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to top handler
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Filter social accounts based on search term (case insensitive)
  const filteredAccounts = socialAccounts.filter(account =>
    account.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="bg-gray-50">
        <div className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom" 
            style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}>
            <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
                <div className="w-full flex justify-center flex-col relative">
                  <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600" style={{color: '#DB2777'}}>Social Profile</h1>
                </div>
            </div>
        </div>

        <div className="bg-white">
          <div className="block mx-auto max-w-screen-2xl">
            <ChatPopup />
          </div>

          <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
            {/* 🔍 Search */}
            <div className="grid grid-cols-12 mb-6">
              <div className="col-span-12">
                <TextField
                  fullWidth
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder={language === "en" ? "Search Social Profiles..." : "सोशल प्रोफाइल खोजें..."}
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: 50,
                      backgroundColor: "#fff",
                    },
                  }}
                />
              </div>
            </div>

            {/* 🎴 Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {socialAccounts
                .filter((account) =>
                  account.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  account.title.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((account) => (
                  <SocialAccountCard
                    key={account.id}
                    name={account.name}
                    title={account.title}
                    icon={account.icon}
                    url={account.url}
                  />
                ))}
            </div>
          </div>

          {showScrollButton && (
            <button
              className="fixed bottom-[100px] right-8 bg-pink-600 hover:bg-emerald-600 text-white p-3 rounded-full shadow-lg"
              onClick={scrollToTop}
            >
              ⬆️
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default SocialPage;
